module.exports = "/assets/data/3594fd605a69896684680d18d8d14fa5-DE15.data.json";